/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState, useMemo, useCallback, useRef } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';

import styles from './MLGatewayCompRaterWizardSideBar.module.scss';
import messages from './MLGatewayCompRaterWizardSideBar.messages';


import { Icon } from '@jutro/legacy/components';


const STATUS_COMPLETE = 'complete';
const STATUS_ACTIVE = 'active';
const STATUS_PENDING = 'pending';


function renderCompRaterWizardSteps(translator, steps) {
    const getGeneralSteps = (parentDivStyles, step, index, changeTransactionClassName) => {
        return (
            <div className={parentDivStyles}>
                <div className={classNames(styles.iconClass)}>
                    <li 
                        className={
                            classNames(changeTransactionClassName || 'ml-leftrail-nav__menu-item',
                                {
                                    active: step.status === STATUS_ACTIVE
                                })
                        }
                        key={step.id}
                    >
                        { !changeTransactionClassName && <span 
                            className={
                                classNames(
                                    {
                                        'ml-count-icon large static light': step.status === STATUS_PENDING,
                                        'icon-ml-status-check-complete': step.status === STATUS_COMPLETE,
                                        'icon-ml-status-check-active': step.status === STATUS_ACTIVE
                                    })
                            }
                        >
                            {
                                step.status === STATUS_PENDING &&
                                <span>{ index + 1 }</span>
                            }
                        </span>}
                        { changeTransactionClassName && <span
                            className={
                                classNames(
                                    {
                                        'icon-ml-status-check-active': step.status !== STATUS_COMPLETE,
                                        'icon-ml-status-check-complete': step.status === STATUS_COMPLETE
                                    }
                                )
                            }
                        /> }
                        {translator(step.title)}
                    </li>
                </div>
            </div>
        )
    }

    return steps.map((step, index) => {
        const parentDivStyles = classNames({
            [styles.hidden]: false,
            [styles.noBullet]: true,
        });
        return (
            getGeneralSteps(parentDivStyles, step, index, 'ml-leftrail-nav__menu-item')
        );
    });
}

function MLGatewayCompRaterWizardSideBar(props) {
    const { bridgedQuoteData, steps, history } = props;
    const modalApi = useModal();
    const { runtimeEnv = '' } = appConfig;
    const prodEnvironmentUrl = runtimeEnv === 'local' ? '' : '/producer-engage'
    const { authHeader } = useAuthentication();
    const { UserService } = useDependencies('UserService');
    const [currentUser, setCurrentUser] = useState({});
    const [wizardSteps, setWizardSteps] = useState([]);
    const translator = useTranslator();
    const ModalService = MLModalService();
    const userRef = useRef();
    userRef.current = currentUser;

    const getUser_Ext = useCallback((includeProducerCode = false) => {
        return UserService.getCurrentUser(authHeader, includeProducerCode);
    }, [UserService, authHeader]);

    const filterActiveProducerCodes_Ext = (user) => {
        if (user.producerCodes_ML && user.producerCodes_ML.length) {
            user.producerCodes_ML = user.producerCodes_ML.filter((prodCode) => {
                return prodCode.producerStatus_ML === 'Active';
            });
        }

        setCurrentUser(user);
        return user.producerCodes_ML;
    };

    const initUser_Ext = () => { 
        getUser_Ext().then((user) => {
            filterActiveProducerCodes_Ext(user);
        });
    };

    useEffect(() => {
        initUser_Ext();

        const visibleSteps = steps?.filter((step) => !step.stepProps.sidebarConfig.stepHidden);
        setWizardSteps(visibleSteps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const goToAccountSummary = () => {
        history.push(`/accounts/${bridgedQuoteData.accountNumber}/summary`);
    };

    const getSidebar = () => {
        return (
            <div>
                {/* Account Details */}
                <header className="ml-leftrail-nav__header clearfix">
                    <section className="ml-leftrail-nav__header-section clearfix user-icon-section clearfix">
                        <div className="ml-leftrail-nav__header-section-icon">
                            <Icon icon="mi-account-circle" className={styles.accountIcon} />
                        </div>
                        <div className="ml-leftrail-nav__header-section-content">
                            <h2 
                                onClick={goToAccountSummary}
                                className={styles.accountName}
                            >
                                {_.get(bridgedQuoteData, 'accountHolderName')}    
                                <Icon icon="mi-arrow-right" />                       
                            </h2> 
                        </div>
                    </section>
                </header>
            </div>
        );
    }

    return (
        <div className="ml-leftrail-nav">
            {getSidebar()}

            <div role="navigation" aria-label="compRaterWizardSidebar">
                <ul className="ml-leftrail-nav__menu">
                {renderCompRaterWizardSteps(
                    translator,
                    wizardSteps
                    )
                }
                </ul>
            </div>
        </div>
    );
}

MLGatewayCompRaterWizardSideBar.propTypes = {
    customMessageModal: PropTypes.shape({})
};
MLGatewayCompRaterWizardSideBar.defaultProps = {
    customMessageModal: {}
};
export default withRouter(MLGatewayCompRaterWizardSideBar);
